import { Box, Grid, Typography } from '@mui/material';

import React from 'react';
import { makeStyles } from '@mui/styles';
import './Footer.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithubSquare } from '@fortawesome/free-brands-svg-icons';
import { faTwitterSquare } from '@fortawesome/free-brands-svg-icons';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';

const footer = {
  borderRadius: '10px 10px 0 0'
};

const Footer = () => {
  const github = <FontAwesomeIcon icon={faGithubSquare} />;
  const twitter = <FontAwesomeIcon icon={faTwitterSquare} />;
  const linkedin = <FontAwesomeIcon icon={faLinkedin} />;

  const useStyle = makeStyles({
    socialIcon: {
      paddingRight: '15px'
    },
    socialLink: {
      color: 'white',
      textDecoration: 'none'
    },
    socialLinkText: {
      textDecoration: 'none'
    }
  });

  const { socialIcon, socialLink, socialLinkText } = useStyle();

  return (
    <Box className="footer" sx={footer}>
      <Grid className="grid-container" sx={{ color: 'white', pb: 5 }}>
        <Grid container sx={{ py: 5, width: '80%', mx: 'auto' }}>
          <Grid item xs={12} md={6}>
            <Box>
              <Typography
                variant="h5"
                sx={{
                  mb: 3,
                  borderBottom: 2,
                  width: '50%',
                  mx: 'auto',
                  paddingBottom: 1
                }}
              >
                About Me
              </Typography>
              <Typography>
                I am working on Frontend UI, Complex User Interfaces, and other
                frontend-related features and services. I offer Portfolio
                Website development, E-Commerce development, E-Voting Web App
                development, and customized website development with demanded
                features based on the client's requirements.
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            sx={{ mt: { xs: 5, sm: 5, md: 0, lg: 0, xl: 0 } }}
          >
            <Typography
              variant="h5"
              sx={{
                mb: 3,
                borderBottom: 2,
                width: '50%',
                mx: 'auto',
                paddingBottom: 1
              }}
            >
              Find Me
            </Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                <a
                  href="https://github.com/kawsar130"
                  target="_blank"
                  rel="noreferrer"
                  className={socialLinkText}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <Typography
                      className={socialIcon}
                      variant="h5"
                      sx={{ color: 'white' }}
                    >
                      {github}
                    </Typography>
                    <Typography className={socialLink}>GitHub</Typography>
                  </Box>
                </a>
                <a
                  href="https://www.linkedin.com/in/kawsar130/"
                  target="_blank"
                  rel="noreferrer"
                  className={socialLinkText}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <Typography
                      className={socialIcon}
                      variant="h5"
                      sx={{ color: 'white' }}
                    >
                      {linkedin}
                    </Typography>
                    <Typography className={socialLink}>LinkedIn</Typography>
                  </Box>
                </a>
                <a
                  href="https://twitter.com/kawsar130"
                  target="_blank"
                  rel="noreferrer"
                  className={socialLinkText}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <Typography
                      className={socialIcon}
                      variant="h5"
                      sx={{ color: 'white' }}
                    >
                      {twitter}
                    </Typography>
                    <Typography className={socialLink}>Twitter</Typography>
                  </Box>
                </a>
              </Box>
            </Box>
          </Grid>
        </Grid>
        <Box
          sx={{
            mt: 3,
            py: 1,
            border: 2,
            borderRadius: 3,
            width: { xs: '300px', sm: '350px', md: '400px' },
            mx: 'auto'
          }}
        >
          <Typography>Have Any Query? Feel Free to Contact</Typography>
          <a
            href="mailto:kawsarahmed130@gmailc.com"
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            <Typography>kawsarahmed130@gmail.com</Typography>
          </a>
        </Box>
      </Grid>
    </Box>
  );
};

export default Footer;
